<template>
    <v-container fluid>
      <v-card elevation="2">
        <v-card-title class="d-flex align-center pe-2 tableheader white--text">
          <v-icon left color="white">mdi-credit-card-outline</v-icon>
          Payments
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            density="compact"
            label="Search (Serial, Tenant, Unit)"
            prepend-inner-icon="mdi-magnify"
            variant="solo-filled"
            flat
            hide-details
            single-line
            class="me-2 search-field"
          ></v-text-field>
          <v-btn color="primary" @click="openAddDialog" :loading="dialogLoading" v-if="authStore.canEdit">
            <v-icon left>mdi-plus</v-icon> Add Payment
          </v-btn>
          <!-- <ExportButtons entity="payments" filename="Payments" :exclude="['id','created_at','updated_at', 'invoice_id', 'payment_method', 'effective_start_date', 'effective_end_date']"></ExportButtons> -->
          <ExportButtons entity="payments" filename="Payments" :headers="headers"></ExportButtons>
        </v-card-title>
  
        <v-divider></v-divider>
  
        <v-data-table
          :headers="headers"
          :items="payments"
          :search="search"
          item-value="id"
          class="elevation-1"
          :loading="tableLoading"
          loading-text="Loading payments... Please wait"
          hover
        >
          <template v-slot:[`item.tenant_name`]="{ item }">
            {{ item.tenant_first_name }} {{ item.tenant_last_name }}
          </template>
          <template v-slot:[`item.payment_date`]="{ value }">
            {{ formatDateForDisplay(value) }}
          </template>
          <template v-slot:[`item.amount_paid`]="{ value }">
              {{ formatCurrency(value) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip location="top" text="View Details">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" small class="me-1" @click="openViewDialog(item)" color="info">
                mdi-eye-outline
              </v-icon>
            </template>
            </v-tooltip>

            <v-tooltip location="top" text="Edit">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" small class="me-1" @click="editItem(item)" color="secondary" v-if="authStore.isAdmin || authStore.canEdit">mdi-pencil</v-icon>
            </template>
          </v-tooltip>
          
          <v-tooltip location="top" text="Delete">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" small @click="deleteItemPrompt(item)" color="error" v-if="authStore.isAdmin">mdi-delete</v-icon>
            </template>
          </v-tooltip>

          <v-tooltip location="top" text="Print Receipt">
              <template v-slot:activator="{ props }">
                <!-- <RouterLink :to="{ name: 'ReceiptPrint', params: { id: item.id } }" target="_blank"> -->
                  <v-icon v-bind="props" small class="me-1" color="info" @click="printReceipt(item)">
                    mdi-printer
                  </v-icon>
                <!-- </RouterLink> -->
              </template>
          </v-tooltip>
          </template>

          <template v-slot:[`no-data`]>
            <v-alert :value="true" color="info" icon="mdi-information-variant" class="ma-3">
              {{ tableLoading ? 'Fetching data...' : 'No payments available.' }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="dialog" persistent max-width="750px" @update:modelValue="val => !val && closeDialog()">
        <v-card :loading="dialogLoading || loadingFormData">
          <v-card-title class="tableheader white--text">
            <span class="text-h5">{{ formTitle }}</span>
          </v-card-title>
          <v-form ref="paymentForm" v-model="isFormValid" @submit.prevent="saveItem">
            <v-card-text class="mt-4">
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="editedItem.tenant_id"
                      :items="availableTenants"
                      item-title="fullName"
                      item-value="id"
                      label="Tenant*"
                      variant="outlined"
                      :rules="[rules.required]"
                      required
                      :loading="loadingTenants"
                      @update:modelValue="onTenantChange"
                    ></v-select>
                  </v-col>
                   <v-col cols="12" md="6">
                    <v-select
                      v-model="editedItem.unit_id"
                      :items="availableUnits"
                      item-title="name"
                      item-value="id"
                      label="Unit*"
                      variant="outlined"
                      :rules="[rules.required]"
                      required
                      :loading="loadingUnits"
                      @update:modelValue="onUnitChange"
                    ></v-select>
                  </v-col>
                  <!-- <v-col cols="12" md="6">
                     <v-text-field
                      v-model="editedItem.unit_name"
                      label="Unit Name (auto-filled)"
                      variant="outlined"
                      readonly
                      filled
                    ></v-text-field>
                  </v-col> -->
                   <!-- <v-col cols="12" md="6">
                    <v-select
                      v-model="editedItem.occupancy_id"
                      :items="availableOccupancies"
                      :item-title="item => `ID: ${item.id} (Unit: ${item.unit_name}, ${formatDateForDisplay(item.start_date)})`"
                      item-value="id"
                      label="Related Occupancy (Optional)"
                      variant="outlined"
                      clearable
                      :loading="loadingOccupancies"
                      :disabled="!editedItem.tenant_id || !editedItem.unit_id"
                    ></v-select>
                  </v-col> -->
                  <v-col cols="12" md="6">
                     <v-text-field
                      v-model="editedItem.payment_date"
                      label="Payment Date*"
                      type="date"
                      variant="outlined"
                      :rules="[rules.required, rules.validDate]"
                      required
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editedItem.payment_serial"
                      label="Payment Serial/Ref No.*"
                      variant="outlined"
                      :rules="[rules.required, rules.maxLength(50)]"
                      required
                    ></v-text-field>
                  </v-col> -->
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model.number="editedItem.amount_paid"
                      label="Amount Paid*"
                      type="number"
                      :prefix="getCurrencyPrefix()"
                      variant="outlined"
                      :rules="[rules.required, rules.positiveNumber]"
                      required
                    ></v-text-field>
                  </v-col>
                   <v-col cols="12">
                    <v-textarea
                      v-model="editedItem.payment_details"
                      label="Payment Details (Optional)"
                      variant="outlined"
                      rows="3"
                    ></v-textarea>
                  </v-col>

                  <!-- new fields -->
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editedItem.effective_start_date"
                      label="Effective Start Date*"
                      variant="outlined"
                      type="date"
                      :rules="[rules.required]"
                      required
                    ></v-text-field>                    
                  </v-col>
                  
                  <v-col cols="12" md="6">
                  <v-text-field
                      v-model="editedItem.effective_end_date"
                      label="Effective End Date*"
                      variant="outlined"
                      type="date"
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-select
                      v-model="editedItem.payment_method"
                      :items="paymentMethods"
                      item-title="text"
                      item-value="value"
                      label="Payment Method"
                      variant="outlined"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="editedItem.status"
                      :items="paymentStates"
                      item-title="text"
                      item-value="value"
                      label="Status"
                      variant="outlined"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editedItem.reference_number"
                      label="Reference Number"
                      variant="outlined"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editedItem.invoice_id"
                      label="Invoice ID"
                      variant="outlined"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editedItem.receipt_number"
                      label="Receipt Number"
                      variant="outlined"
                    ></v-text-field>
                  </v-col> -->
                  
                  <!-- end new fields -->

                </v-row>
              </v-container>
              <small class="pl-3">*indicates required field</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey-darken-1" variant="text" @click="closeDialog" :disabled="dialogLoading">Cancel</v-btn>
              <v-btn color="primary" variant="elevated" type="submit" :loading="dialogLoading" :disabled="!isFormValid || loadingFormData">Save</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
  
      <v-dialog v-model="viewDialog" max-width="800px" @update:modelValue="val => !val && closeViewDialog()">
      <v-card :loading="viewDialogLoading">
        <v-card-title class="tableheader white--text d-flex align-center">
          <v-icon left color="white" class="mr-2">mdi-credit-card-outline</v-icon>
          <span class="text-h5">Payment Details: {{ viewItem?.receipt_number }}</span>
          <v-spacer></v-spacer>
          <v-btn icon="mdi-close" variant="text" color="white" @click="closeViewDialog"></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="viewItem" class="pt-4">
          <v-list lines="two" density="compact">
            <!-- <v-list-item title="ID" :subtitle="viewItem.id"></v-list-item><v-divider inset></v-divider> -->
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Payment Date:</div>
              </template>
              <v-list-item-text class="text-right pl-2"> {{ formatDateForDisplay(viewItem.payment_date) }} </v-list-item-text>
            </v-list-item><v-divider inset></v-divider>

            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Tenant:</div>
              </template>
              <v-list-item-text class="text-right pl-2"> {{ viewItem.tenant_first_name }} {{ viewItem.tenant_last_name }} </v-list-item-text>
            </v-list-item><v-divider inset></v-divider>

            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Unit:</div>
              </template>
              <v-list-item-text class="text-right pl-2"> {{ viewItem.unit_name }} </v-list-item-text>
            </v-list-item><v-divider inset></v-divider>
            
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Amount Paid:</div>
              </template>
              <v-list-item-text class="text-right pl-2"> {{ formatCurrency(viewItem.amount_paid) }} </v-list-item-text>
            </v-list-item><v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Payment Details:</div>
              </template>
              <v-list-item-text class="text-right pl-2"> {{ viewItem.payment_details }} </v-list-item-text>
            </v-list-item><v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Effective Start Date:</div>
              </template>
              <v-list-item-text class="text-right pl-2"> {{ formatDateForDisplay(viewItem.effective_start_date) }} </v-list-item-text>
            </v-list-item><v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Effective End Date:</div>
              </template>
              <v-list-item-text class="text-right pl-2"> {{ formatDateForDisplay(viewItem.effective_end_date) }} </v-list-item-text>
            </v-list-item><v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Payment Method:</div>
              </template>
              <v-list-item-text class="text-right pl-2"> {{ viewItem.payment_method }} </v-list-item-text>
            </v-list-item><v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Status:</div>
              </template>
              <v-list-item-text class="text-right pl-2"> {{ formatPaymentStatus(viewItem.status) }} </v-list-item-text>
            </v-list-item><v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Receipt Number:</div>
              </template>
              <v-list-item-text class="text-right pl-2"> {{ viewItem.receipt_number }} </v-list-item-text>
            </v-list-item><v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Reference Number:</div>
              </template>
              <v-list-item-text class="text-right pl-2"> {{ viewItem.reference_number }} </v-list-item-text>
            </v-list-item><v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Invoice ID:</div>
              </template>
              <v-list-item-text class="text-right pl-2"> {{ viewItem.invoice_id }} </v-list-item-text>
            </v-list-item><v-divider inset></v-divider>
          </v-list>
        </v-card-text>
        <v-card-text v-else class="text-center py-5">
            <v-progress-circular indeterminate color="primary" class="mb-3"></v-progress-circular>
            <p>Loading payment details...</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="bg-grey-lighten-4 pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="tonal" @click="closeViewDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-dialog v-model="deleteDialog" max-width="500px">
        <v-card :loading="dialogLoading">
          <v-card-title class="text-h5">Confirm Deletion</v-card-title>
          <v-card-text>
            Are you sure you want to delete this payment record (Receipt No. {{ itemToDelete?.receipt_number }})?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue-darken-1" text @click="closeDeleteDialog" :disabled="dialogLoading">Cancel</v-btn>
            <v-btn color="red-darken-1" text @click="confirmDelete" :loading="dialogLoading">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" bottom right>
        {{ snackbar.message }} <template v-slot:actions><v-btn color="white" variant="text" @click="snackbar.show = false">Close</v-btn></template>
      </v-snackbar>
    </v-container>
  </template>
  
  <script setup>
  import { ref, computed, onMounted, nextTick } from 'vue';
  import PaymentService from '@/services/PaymentService';
  import TenantService from '@/services/TenantService';
  import UnitService from '@/services/UnitService';
  // import OccupancyService from '@/services/OccupancyService'; // To fetch occupancies for linking
  import { useAuthStore } from '@/stores/auth';
  import { formatDateForDisplay, formatCurrency, getCurrencyPrefix, useSnackbar } from '@/services/genFunctions';
  import ExportButtons from '@/components/ExportButtons.vue';
  import { useRouter } from 'vue-router';
  // import ReceiptPrint from '@/components/ReceiptPrint.vue';

  const authStore = useAuthStore();
  const { snackbar, showSnackbar } = useSnackbar();
  const router = useRouter();
  const search = ref('');
  const tableLoading = ref(true);
  const dialog = ref(false);
  const dialogLoading = ref(false);
  const deleteDialog = ref(false);
  const paymentForm = ref(null);
  const isFormValid = ref(false);
  const loadingFormData = ref(false); // For all dropdowns
  
  const paymentMethods = [
    { text: 'Cash', value: 'cash' },
    { text: 'Check', value: 'check' },
    { text: 'Bank Transfer', value: 'banktransfer' },
    { text: 'Credit Card', value: 'creditcard' },
    { text: 'Mobile Money', value: 'mobilemoney' }
  ];
  const paymentStates = [
    { text: 'Pending', value: 'pending' },
    { text: 'Completed', value: 'completed' },
    { text: 'Failed', value: 'failed' }
  ];

  // const snackbar = ref({ show: false, message: '', color: 'success', timeout: 3000 });
  // const showSnackbar = (message, color = 'success', timeout = 3000) => ({ snackbar: { value: { message, color, timeout, show: true } } });
  
  const defaultItem = {
    id: null,
    unit_id: null,
    tenant_id: null,
    occupancy_id: null,
    payment_date: null,
    payment_serial: '',
    unit_name: '', // Will be auto-filled or from fetched data
    amount_paid: null,
    payment_details: '',
    effective_start_date: null,
    effective_end_date: null,
    payment_method: null,
    status: null,
    invoice_id: null,
    receipt_number: null,
    reference_number: null,
  };
  const editedItem = ref({ ...defaultItem });
  const itemToDelete = ref(null);
  
  const availableTenants = ref([]);
  const loadingTenants = ref(false);
  const availableUnits = ref([]);
  const loadingUnits = ref(false);
  const availableOccupancies = ref([]); // For dropdown
  // const allOccupanciesForTenantAndUnit = ref([]); // Temp store for filtering
  // const loadingOccupancies = ref(false);
  const viewDialog = ref(false);
  const viewDialogLoading = ref(false);
  const viewItem = ref(null);

  const rules = {
    required: value => !!value || 'This field is required.',
    positiveNumber: value => (typeof value === 'number' && value > 0) || 'Must be a positive number > 0.',
    validDate: value => /^\d{4}-\d{2}-\d{2}$/.test(value || '') || 'Invalid date format (YYYY-MM-DD).',
    maxLength: (len) => value => (value || '').length <= len || `Max ${len} characters.`
  };
  
  const headers = ref([
    // { title: 'ID', key: 'id', align: 'start', sortable: true, width: '70px' },
    { title: 'Payment Date', key: 'payment_date', sortable: true },
    { title: 'Payment Status', key: 'status', sortable: true },
    // { title: 'Bank or Pay Serial No.', key: 'payment_serial', sortable: true },
    { title: 'Tenant', key: 'tenant_name', value: item => `${item.tenant_first_name || ''} ${item.tenant_last_name || ''}`.trim() || 'N/A', sortable: true },
    { title: 'Unit Name', key: 'unit_name', sortable: true },
    { title: 'Amount Paid', key: 'amount_paid', align: 'end', sortable: true },
    { title: 'Details', key: 'payment_details', sortable: false, width: '200px' },
    { title: 'Payment Reference', key: 'reference_number', sortable: true },
    { title: 'Receipt No.', key: 'receipt_number', sortable: true },
    { title: 'Actions', key: 'actions', sortable: false, align: 'center', width: '150px' }
  ]);
  
  const payments = ref([]);
  
  const fetchPayments = async () => {
    tableLoading.value = true;
    try {
      payments.value = await PaymentService.getPayments();
    } catch (error) {
      console.error("Error fetching payments:", error);
      showSnackbar('Failed to load payments.', 'error');
      payments.value = [];
    } finally {
      tableLoading.value = false;
    }
  };
  
  const formatPaymentStatus = (status) => {
    return status === 'pending' ? 'Pending' : status === 'completed' ? 'Completed' : status === 'failed' ? 'Failed' : status;
  };
  
  const fetchDropdownData = async () => {
    loadingFormData.value = true;
    loadingTenants.value = true;
    loadingUnits.value = true;
    try {
      const tenantsData = await TenantService.getTenants();
      availableTenants.value = tenantsData.map(t => ({ ...t, fullName: `${t.first_name} ${t.last_name}` }));
  
      const unitsData = await UnitService.getUnits();
      availableUnits.value = unitsData;
      // Occupancies will be fetched when tenant/unit changes
    } catch (error) {
      console.error("Error fetching base form data for payments:", error);
      showSnackbar('Failed to load tenant/unit data for form.', 'error');
    } finally {
      loadingTenants.value = false;
      loadingUnits.value = false;
      loadingFormData.value = false;
    }
  };
  
  const onUnitChange = (unitId) => {
      const selectedUnit = availableUnits.value.find(u => u.id === unitId);
      if (selectedUnit) {
          editedItem.value.unit_name = selectedUnit.name;
      } else {
          editedItem.value.unit_name = '';
      }
  };
  const onTenantChange = async () => {
    // get the tenant unit
    const tenantUnit = await PaymentService.fetchTenantsUnit(editedItem.value.tenant_id)
    console.log("tenantUnit:", tenantUnit );
    // availableUnits.value = tenantUnits;
    if (tenantUnit) {
      editedItem.value.unit_id = tenantUnit.id;
      editedItem.value.unit_name = tenantUnit.name;
    } else {
      editedItem.value.unit_id = null;
      editedItem.value.unit_name = null;
    }
  }
  
  
  onMounted(() => {
    fetchPayments();
    fetchDropdownData();
  });
  
  const formTitle = computed(() => !editedItem.value.id ? 'New Payment Record' : 'Edit Payment Record');
  
  const openAddDialog = () => {
    editedItem.value = { ...defaultItem, payment_date: new Date().toISOString().split('T')[0] };
    availableOccupancies.value = []; // Clear previous occupancies
    dialog.value = true;
    nextTick(() => paymentForm.value?.resetValidation());
  };
  
  const editItem = (item) => {
    editedItem.value = { 
      ...item,
      payment_date: item.payment_date ? item.payment_date.split('T')[0] : null,
      // Ensure IDs are numbers if v-select expects numbers from backend (which it should get)
      tenant_id: Number(item.tenant_id),
      unit_id: Number(item.unit_id),
      occupancy_id: item.occupancy_id ? Number(item.occupancy_id) : null,
    };
    // Pre-fill unit name for edit
    const unit = availableUnits.value.find(u => u.id === item.unit_id);
    if (unit) editedItem.value.unit_name = unit.name;
  
    dialog.value = true;

    setValidOccupancy(editedItem.value.tenant_id, editedItem.value.unit_id);
    
    nextTick(() => paymentForm.value?.resetValidation());
  };

  const setValidOccupancy = async (tenant_id, unit_id) => {
    const occupancy_id = await PaymentService.fetchTenantAndUnitOccupancy(tenant_id, unit_id)
    console.log("occupancy_id:", occupancy_id);
    console.log("tenant_id:", tenant_id);
    console.log("unit_id:", unit_id);

    if (!occupancy_id || occupancy_id === null) {
      showSnackbar('No matching occupancy found for this tenant and unit combination.', 'error');
      editedItem.value.occupancy_id = null;
      return false;
    } else {
      editedItem.value.occupancy_id = occupancy_id;
    }

    return true;
  }

  const printReceipt = (item) => {
    router.push({ name: 'ReceiptPrint', params: { id: item.id } });
  };

  const deleteItemPrompt = (item) => {
    itemToDelete.value = { ...item };
    deleteDialog.value = true;
  };
  
  const closeDialog = async () => {
    dialog.value = false;
    await nextTick();
    editedItem.value = { ...defaultItem };
    paymentForm.value?.resetValidation();
    dialogLoading.value = false;
    availableOccupancies.value = []; // Clear occupancies list
  };
  
  const closeDeleteDialog = () => { /* ... similar to other pages ... */ 
      deleteDialog.value = false;
      nextTick(() => itemToDelete.value = null);
      dialogLoading.value = false;
  };
  
  const saveItem = async () => {
    if (!paymentForm.value) return;
    const { valid } = await paymentForm.value.validate();
    if (!valid) {
      showSnackbar('Please correct the form errors.', 'warning');
      return;
    }

    const validOccupancy = await setValidOccupancy(editedItem.value.tenant_id, editedItem.value.unit_id);
    if (!validOccupancy) return;

    dialogLoading.value = true;
    try {
      // The unit_name in editedItem.value should be correct due to onUnitChange
      if (editedItem.value.id) {
        const updatedRecord = await PaymentService.updatePayment(editedItem.value.id, editedItem.value);
        const index = payments.value.findIndex(p => p.id === updatedRecord.id);
        if (index > -1) payments.value.splice(index, 1, updatedRecord);
        else await fetchPayments();
        showSnackbar('Payment record updated successfully!', 'success');
      } else {
        const newRecord = await PaymentService.createPayment(editedItem.value);
        payments.value.unshift(newRecord);
        showSnackbar('Payment record created successfully!', 'success');
      }
      closeDialog();
    } catch (error) {
      console.error("Error saving payment record:", error.response?.data?.error || error.message);
      showSnackbar(`Error: ${error.response?.data?.error || 'Could not save payment.'}`, 'error', 5000);
    } finally {
      dialogLoading.value = false;
    }
  };
  
  const confirmDelete = async () => { /* ... similar to other pages ... */ 
      if (!itemToDelete.value?.id) return;
      dialogLoading.value = true;
      try {
          await PaymentService.deletePayment(itemToDelete.value.id);
          payments.value = payments.value.filter(p => p.id !== itemToDelete.value.id);
          showSnackbar('Payment record deleted successfully!', 'success');
          closeDeleteDialog();
      } catch (error) {
          console.error("Error deleting payment record:", error);
          showSnackbar(`Error: ${error.response?.data?.error || 'Could not delete payment.'}`, 'error', 5000);
      } finally {
          dialogLoading.value = false;
      }
  };

  const openViewDialog = async (item) => {
      viewDialogLoading.value = true;
      viewDialog.value = true;
      viewItem.value = null; 
      try {
        const fullPaymentData = await PaymentService.getPayment(item.id);
        viewItem.value = fullPaymentData;
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Failed to load payment details.';
      showSnackbar(errorMsg, 'error');
      console.error("Error fetching payment details for view:", error);
      viewDialog.value = false; 
    } finally {
      viewDialogLoading.value = false;
    }
  };

  const closeViewDialog = () => {
    viewDialog.value = false;
    viewItem.value = null;
  };

  </script>
  
  <!-- <style scoped>
  .fill-height {
    min-height: calc(100vh - 64px); /* Adjusted for no footer on register page */
  }
  .primary--text { color: var(--v-theme-primary) !important; }
  .text-primary { color: var(--v-theme-primary) !important; }
  .v-card { border-top: 4px solid var(--v-theme-primary); }
  .v-toolbar-title { line-height: 1.5rem; }
  </style> -->